import { Image } from "../../components/Image";
import { useEffect, useState, useRef } from "react";

import { hitDeeplinkPerformAction } from "../../utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "../../utils/constants";
import { getAwsAssets } from "../../utils";
import { hitDeeplinkExecutedV2 } from "../../utils/hitDeeplink";
import { getLiveCardCtaText } from "../../utils/liveService/util";
import "./UpcomingLiveCard.scss"

const UpcomingLiveCard = ({ upcomingClass, index, deeplink, isAgora, emblem4 }) => {
  const [disableButton, setDisableButton] = useState(true);

  const timeoutRef = useRef(null);

  useEffect(() => {
    // console.log("SETTIMEOUT__BUTTONSTATE");
    if (upcomingClass?.scheduleTime) {
      if (upcomingClass?.scheduleTime - new Date().getTime() <= 86400000) {
        timeoutRef.current = setTimeout(() => {
          setDisableButton(false);
        }, upcomingClass?.scheduleTime - new Date().getTime());
      }
    }
    // console.log("SETTIMEOUT__BUTTONSTATE", disableButton);
    return () => clearTimeout(timeoutRef?.current);
  }, [index, upcomingClass?.scheduleTime]);

  const classTime = new Date(upcomingClass?.scheduleTime)?.toLocaleString(
    "en-US",
    {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }
  );

  const date = new Date(upcomingClass.scheduleTime);
  const upcomingClassDate = date.getDate();
  const upcomingClassMonth = date.toLocaleString("en-us", { month: "short" });

  return (
    <div className="UpcomingLiveCard">
      <div className="UpcomingLiveCard__image">
        <Image
          src={getAwsAssets("Vector.svg", "liveClasses")}
          alt="like"
          height={48}
          width={48}
        />
        <div className="UpcomingLiveCard__image__date">
          <p>{upcomingClassDate}</p>
          <p>{upcomingClassMonth}</p>
        </div>
      </div>
      <div className="UpcomingLiveCard__item1">
        <p className="UpcomingLiveCard__item1__para">{classTime}</p>
        <div className="UpcomingLiveCard__item1__content">
          <div className="UpcomingLiveCard__item1__content__wrapper">
          <p className="UpcomingLiveCard__item1__content__para1">
            {upcomingClass.title}
          </p>
          {upcomingClass?.tutorName ? (
            <p className="UpcomingLiveCard__item1__bottom_para">
              By {upcomingClass?.tutorName}
            </p>
          ) : null}
          </div>
          <button
            className="UpcomingLiveCard__item1__content__para2"
            disabled={disableButton}
            onClick={() => {
              isAgora
                ? hitDeeplinkExecutedV2(
                  JSON.stringify(deeplink),
                  JSON.stringify(deeplink)
                )
                : hitDeeplinkPerformAction(
                  COMMON_DEEPLINK_ACTIONS.OPEN_GO_LIVE,
                  JSON.stringify(deeplink),
                  JSON.stringify(deeplink)
                );
            }}
          >
            {getLiveCardCtaText(upcomingClass?.liveCard)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpcomingLiveCard;
